import { forwardRef } from "react";
export var fixedForwardRef = forwardRef;
